import { render, staticRenderFns } from "./TaskReport.vue?vue&type=template&id=4ed4f2b8&"
import script from "./TaskReport.vue?vue&type=script&lang=js&"
export * from "./TaskReport.vue?vue&type=script&lang=js&"
import style0 from "./TaskReport.vue?vue&type=style&index=0&id=4ed4f2b8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports